export default __webpack_public_path__ + "static/media/avatar_female.0e88dc2e.jpg";